import { render, staticRenderFns } from "./TableV1.vue?vue&type=template&id=2c168209"
import script from "./TableV1.vue?vue&type=script&lang=js"
export * from "./TableV1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports